import React, { useEffect, useState } from "react";
import SideBar from "../SideBar/SideBar";
import SingleBookInfo from "../SingleBookInfo/SingleBookInfo";

const ManageBooks = () => {
  const [booksData, setBooksData] = useState([]);

  useEffect(() => {
    fetch("https://infinite-cliffs-81680.herokuapp.com/books")
      .then((res) => res.json())
      .then((data) => setBooksData(data));
  }, []);
  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-4">
          <div className="">
            <SideBar></SideBar>
          </div>
        </div>

        <div className="col-md-8 border border-3 border-success p-4">
          {booksData.length === 0 && (
            <div className="text-center ">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          <h3>Manage Books</h3>
          <table className="table">
            <thead>
              <tr>
                <th>Book Name</th>
                <th>Author Name</th>
                <th>Price</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {booksData.map((info) => (
                <SingleBookInfo info={info}></SingleBookInfo>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageBooks;
